const PUBLICO = '01'
const PRIVADO = '02'

const __dictionary = {
  [PRIVADO]: {
    id: PRIVADO,
    nombre: 'PRIVADO'
  },
  [PUBLICO]: {
    id: PUBLICO,
    nombre: 'PUBLICO'
  }
}

const __array = [__dictionary[PRIVADO], __dictionary[PUBLICO]]

export default Object.freeze({
  PRIVADO,
  PUBLICO,
  __dictionary,
  __array
})
